import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useMediaQuery } from 'react-responsive';

import DashboardLink from "Components/DashboardLink/DashboardLink";
import payments from "Assets/Icons/payments.svg";
import account from "Assets/Icons/account.svg";
import plus from "Assets/Icons/plus.svg";
import settings from "Assets/Icons/settings.svg";

import "./DashboardLinks.scss";
import useMode, { MODE } from "Utils/Hooks/useMode";
import useSession from "Utils/Hooks/useSession";

const Dashboard = () => {
  const { session } = useSession();
  const mode = useMode();
  const isMobile = useMediaQuery({
    query: '(max-width: 767.98px)'
  });

  const showDeposit = mode !== MODE.withdraw;
  const showWithdraw = mode !== MODE.deposit;
  const showLimit = session.toggles.limitEnabled;

  const mobileButtons = (!showDeposit && !showWithdraw) ? <Row>
                    <Col className="border-end bottom-link"><DashboardLink text={<div>My Funding<br />Sources</div>} icon={account} link="/myAccounts" /></Col>
                    {showLimit && <Col className="bottom-link"><DashboardLink text={<div>Limit<br />Change</div>} icon={settings} link="/manageLimit" /></Col>}
                  </Row> : 
                  (showDeposit && showWithdraw && !session.transactionSucceeded) ? <div>
                  <Row>
                    <Col className="border-end border-bottom"><DashboardLink text={<div>Deposit<br />Funds</div>} icon={plus} link="/addFunds" /></Col>
                    <Col className="border-bottom"><DashboardLink text={<div>Withdraw<br />Funds</div>} icon={payments} link="/withdrawFunds" /></Col>
                  </Row>
                  <Row>
                    <Col className="border-end bottom-link"><DashboardLink text={<div>My Funding<br />Sources</div>} icon={account} link="/myAccounts" /></Col>
                    {showLimit && <Col className="bottom-link"><DashboardLink text={<div>Limit<br />Change</div>} icon={settings} link="/manageLimit" /></Col>}
                  </Row>
                </div> : 
                <div><Row>
                    {!session.transactionSucceeded && <Col className={showLimit ? "border-end border-bottom" : "border-end"}><DashboardLink text={<div>{(showDeposit) ? 'Deposit' : 'Withdraw'}<br />Funds</div>} icon={plus} link={(showDeposit) ? "/addFunds" : "/withdrawFunds"}/></Col>}
                    <Col className={showLimit && "border-bottom"}><DashboardLink text={<div>My Funding<br />Sources</div>} icon={account} link="/myAccounts" /></Col>
                  </Row>
                  <Row>
                    {showLimit && <Col className="border-end bottom-link"><DashboardLink text={<div>Limit<br />Change</div>} icon={settings} link="/manageLimit" /></Col>}
                    <Col className="bottom-link"></Col>
                  </Row></div>;

  return (
    <div className="dashboard-links">
      <Container>
        {isMobile && mobileButtons}
        {!isMobile && <Row>
          {(session.transactionSucceeded || !showLimit) && <Col></Col>}
          {showDeposit && !session.transactionSucceeded &&  <Col className="border-end"><DashboardLink text={<div>Deposit<br />Funds</div>} icon={plus} link="/addFunds" /></Col>}
          {showWithdraw && !session.transactionSucceeded && <Col className="border-end"><DashboardLink text={<div>Withdraw<br />Funds</div>} icon={payments} link="/withdrawFunds" /></Col>}
          <Col className={showLimit && "border-end"}><DashboardLink text={<div>My Funding<br />Sources</div>} icon={account} link="/myAccounts" /></Col>
          {showLimit && <Col><DashboardLink text={<div>Limit<br />Change</div>} icon={settings} link="/manageLimit" /></Col>}
          {(session.transactionSucceeded || !showLimit) && <Col></Col>}
        </Row>}        
      </Container>
    </div>
  );
};

export default Dashboard;